export const RECOMMENDATIONS_MICROFRONTEND_NAME = 'recommendations-micro-frontend';

export const RECOMMENTATIONS_MICROFRONTEND_PATH = '/v1/get-recommendations-micro-frontend/';
